import type { GenerationJob } from "../types";

export const GENERATION_PHASE_COUNT = 5;

/**
 * Готовность выпуска в процентах. Считается в одном месте: её показывают и пульт
 * внизу экрана, и полноэкранный оверлей, а расхождение между ними читалось бы как
 * ошибка сервиса. Иллюстрации занимают последнюю часть шкалы, поэтому при их
 * включении текстовые этапы двигают полосу медленнее.
 */
export function jobProgress(job: Pick<GenerationJob, "status" | "phase" | "illustrations">) {
  if (job.status === "completed") return 100;
  if (job.status === "queued") return 5;
  const scenes = job.illustrations.filter((item) => item.index > 0);
  const ready = scenes.filter((item) => item.status === "ready").length;
  const scenePart = scenes.length ? ready / scenes.length * 22 : 0;
  return Math.min(94, (12 + Math.max(0, job.phase) * 20) * (scenes.length ? .78 : 1) + scenePart);
}

/** Короткая строка состояния для пульта: очередь, текущий этап или исход. */
export function jobStatusLine(job: Pick<GenerationJob, "status" | "phaseTitle" | "error">) {
  if (job.status === "queued") return "Ждём свободного рассказчика";
  if (job.status === "failed") return job.error || "Не сложилось";
  if (job.status === "cancelled") return "Отменено";
  if (job.status === "completed") return "Выпуск готов";
  return job.phaseTitle;
}

export function isJobRunning(job: Pick<GenerationJob, "status">) {
  return job.status === "queued" || job.status === "processing";
}
